import {
    API_USER_PROFILE,
    API_ALERT,
    API_WHATNEW_CONTENT,
    API_HOMEPAGE_CONTENT,
    API_DEMO_CATALGUE,
    API_RESET_PAGE_CONTENT,
    API_GET_ALL_TENENT_BOOKINGS,
    API_GET_CONTENT_STORE,
    API_FAQ_QUESTION,
    API_LEARNING_HUB,
    API_LEARNING_HUN_UPDATE_VIDEO_STATUS,
    API_GENERIC_SEARCH,
    API_NARRATIVE_SEARCH,
    API_CONTENT_SEARCH,


    API_FETCH_SE_ANALYTICS,
    API_FETCH_MANAGER_ANALYTICS,
    API_FETCH_LEADERSHIP_ANALYTICS,
    API_FETCH_LEADERSHIP_INTERNAL_SE_ANALYTICS,
    API_FETCH_LEADERSHIP_PARTNER_ANALYTICS,
    API_FETCH_LEADERSHIP_PARTNER_COMPANY_ANALYTICS,
    API_FETCH_LEADERSHIP_BOOTCAMP_STATS,
    API_FETCH_LEADERSHIP_BOOTCAMP_PARTICIPANTS,
    API_FETCH_SE_IMPACT_STATS,
    API_FETCH_VE_IMPACT_STATS,


    // Sales
    API_FETCH_SALES_PERSONAS_HOMEPAGE,
    API_FETCH_EXISTING_DEMO_SESSION,
    API_CREATE_INTERNAL_DEMO_SESSION,
    API_CREATE_CUSTOMER_DEMO_SESSION,
    API_DELETE_DEMO_SESSION,
    API_UPDATE_DEMO_SESSION_STATUS,
    API_GET_SALES_WALKTHROUGH,
    API_UPDATE_SALES_WALKTHROUGH_STATUS,


    // Disclaimer
    API_GET_PARTNER_DISCLAIMER,
    API_UPDATE_DISCLAIMER_STATUS,



    // Get Analytics Filter
    API_GET_ANALYTICS_FILTER,


    API_FAQ_SEARCH,

    API_GET_UPGRADE_PATCHES,

    API_GET_TENANT_SCENARIO_GROUPS,
    API_GET_POLLING_STATUS,
    API_YADS_DEMO_INGESTION,
    API_SCHEDULE_YADS_DEMO_INGESTION,
    API_CANCEL_YADS_SCHEDULE,
    API_YADS_SCHEDULE,

    API_RECURRING_SCHEDULE_YADS_DEMO_INGESTION,
    API_DELETE_YADS_RECURRING_SCHEDULE,
    API_PATCH_YADS_RECURRING_SCHEDULE,

    API_ONBOARD_TENANT,

    API_FORGOT_PASSWORD,
    API_CHANGE_PASSWORD_BY_URL,

    API_PATCH_USER_TENANT,

    API_CANCEL_INGESTION,

    API_DELETE_USER_TENANT,

    API_ACCOUNT_REQUEST,
    API_ADMIN_PENDING_REQUEST,
    API_ADMIN_USER_MODULE_DETAILS,
    API_ADMIN_ACCOUNTS,
    API_ADMIN_RESET_USER_PASSWORD,
    API_ADMIN_PENDING_REQUEST_COUNT,
    API_ADMIN_ACCOUNT_TYPE_MAPPING,
    API_ADMIN_SHARED_TENANT,
    API_ADMIN_BOOKING_LABELS,
    API_ADMIN_BOOKING_TENANT_FEATURES,
    API_ADMIN_BOOKING_VERSION_FEATURES,
    API_ADMIN_UPDATE_FAULT_STATUS,
    API_ADMIN_MASS_PASSWORD_RESET,
    API_ADMIN_CHECK_CLEAN_TENANTS,
    API_RELEASE_TENENT,
    API_ADMIN_ALERT_MESSAGE,
    API_EMAIL_CHANGE_REQUEST,
    API_EMAIL_CHANGE_VERIFY,
    API_EMAIL_CHANGE_RESEND,
    API_EMAIL_CHANGE_STATUS

} from '../Constants/apiUrls'

import axios from 'axios'

// Helper function to handle errors
const stripHtml = (input = '') => input.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();

const extractErrorMessage = (errorBody, errorText = '', fallbackMessage = 'Something went wrong') => {
    if (Array.isArray(errorBody)) {
        const arrayMessage = errorBody
            .map((item) => item?.error || item?.message || item?.msg)
            .find(Boolean);

        return arrayMessage || errorText || fallbackMessage;
    }

    if (typeof errorBody === 'string') {
        const normalized = errorBody.trim();
        if (/<!doctype html|<html|<body|django/i.test(normalized)) {
            return fallbackMessage;
        }
        return stripHtml(normalized) || errorText || fallbackMessage;
    }

    if (errorBody && typeof errorBody === 'object') {
        return (
            errorBody.error ||
            errorBody.message ||
            errorBody.msg ||
            errorText ||
            fallbackMessage
        );
    }

    return errorText || fallbackMessage;
};

const handleErrors = async (response, fallbackMessage = 'Something went wrong') => {
    if (!response.ok) {
        const contentType = response.headers.get('content-type') || '';
        if (contentType.includes('application/json')) {
            try {
                const errorJson = await response.json();
                return extractErrorMessage(errorJson, '', fallbackMessage);
            } catch (e) {
                return fallbackMessage;
            }
        }

        const errorText = await response.text();
        return extractErrorMessage(errorText, '', fallbackMessage);
    }
    return null;
};

const PENDING_REQUEST_MUTABLE_FIELDS = [
    'firstname',
    'lastname',
    'region',
    'subregion',
    'company',
    'manager',
    'typeOfUser',
    'roleOfUser',
    'isManager',
    'canDemo',
    'businessUnit',
    'country',
];

const buildPendingRequestUpdatePayload = (payload = {}) => {
    const sanitizedPayload = PENDING_REQUEST_MUTABLE_FIELDS.reduce((result, field) => {
        if (payload[field] !== undefined) {
            result[field] = payload[field];
        }

        return result;
    }, {});

    if (!Object.keys(sanitizedPayload).length) {
        throw new Error('At least one valid pending request field is required.');
    }

    return sanitizedPayload;
};


// Fetch profile data
export const fetchProfileData = async (accessToken) => {
    const response = await fetch(API_USER_PROFILE, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
};




// Fetch Alert Message
export const fetchAlertMessage = async (accessToken) => {

    const response = await fetch(API_ALERT, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();

}




// Fetch What's New
export const fetchWhatNewContent = async (accessToken) => {

    const response = await fetch(API_WHATNEW_CONTENT, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();

}





// Fetch Homepage Content
export const fetchHomePageContent = async (accessToken) => {

    const response = await fetch(API_HOMEPAGE_CONTENT, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
}




// Demo Catalgue
export const fetchDemoCatalgue = async (accessToken) => {

    const response = await fetch(API_DEMO_CATALGUE, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();

}




// Reset Operation
export const fetchResetPageContent = async (accessToken) => {

    const response = await fetch(API_RESET_PAGE_CONTENT, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
    });

    console.log('API response:', response);

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        console.log('Error message:', errorMessage);
        throw new Error(errorMessage);
    }

    const data = await response.json();
    console.log('Fetched data:', data);
    return data;

}




// Booking
export const fetchAllTenantBooking = async (accessToken) => {

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const response = await fetch(`${API_GET_ALL_TENENT_BOOKINGS}?timezone=${timezone}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();

}




// Content Hub
export const fetchAllContentHub = async (accessToken) => {

    const response = await fetch(API_GET_CONTENT_STORE, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();

}




// FAQ
// export const fetchFAQ = async (accessToken) => {

//     const response = await fetch(API_FAQ_QUESTION, {
//         method: 'GET',
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${accessToken}`,
//         },
//     });

//     const errorMessage = await handleErrors(response);
//     if (errorMessage) {
//         throw new Error(errorMessage);
//     }

//     return await response.json();

// }

export const fetchFAQ = async (token, page, limit) => {
    const response = await fetch(`${API_FAQ_QUESTION}?page=${page}&limit=${limit}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to fetch FAQ');
    }

    return await response.json();
};



// Learning Hub
export const fetchLearningHubData = async (accessToken) => {

    const response = await fetch(API_LEARNING_HUB, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();

}



export const updateVideoStatusLearningHub = async (accessToken, id, certName) => {

    const response = await fetch(API_LEARNING_HUN_UPDATE_VIDEO_STATUS(id), {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();

}




// Generic Search 
export const generi_search = async (accessToken, query) => {

    const response = await fetch(`${API_GENERIC_SEARCH}query=${query}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();

}



// Narrative Search 
export const narrative_search = async (accessToken, query) => {

    const response = await fetch(`${API_NARRATIVE_SEARCH}query=${query}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();

}



// FAQ Search
export const faq_search = async (accessToken, query) => {

    const response = await fetch(`${API_FAQ_SEARCH}query=${query}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();

}




// COntent Search 
export const content_search = async (accessToken, query) => {

    const response = await fetch(`${API_CONTENT_SEARCH}query=${query}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();

}




// Fetch Sales persona Homepage
export const fetchSalesPersonaHomepage = async (accessToken) => {
    const response = await fetch(API_FETCH_SALES_PERSONAS_HOMEPAGE, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
}



// Fetch SE Analytics
export const fetchSEAnalytics = async (accessToken) => {
    const response = await fetch(API_FETCH_SE_ANALYTICS, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
}
// Fetch Manager Analytics
export const fetchMangerAnalytics = async (accessToken, filter) => {
    console.log(filter)
    const response = await fetch(`${API_FETCH_MANAGER_ANALYTICS}${filter}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },

    });
    console.log(response)
    const errorMessage = await handleErrors(response);
    console.log(errorMessage)
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
}




// Fetch Leadership Console
export const fetchLeadershipAnalytics = async (accessToken, filter) => {
    console.log(filter)
    const response = await fetch(`${API_FETCH_LEADERSHIP_ANALYTICS}${filter}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },

    });
    console.log(response)
    const errorMessage = await handleErrors(response);
    console.log(errorMessage)
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
}

const fetchImpactAnalyticsHtml = async (accessToken, apiUrl, unavailableMessage, loadErrorMessage) => {
    const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    let data = {};
    try {
        data = await response.json();
    } catch (e) {
        data = {};
    }

    if (!response.ok || !data.success) {
        const nestedMessage = data?.error?.message;
        const flatMessage = typeof data?.error === 'string' ? data.error : null;
        const fallbackMessage = response.status === 404
            ? unavailableMessage
            : loadErrorMessage;
        throw new Error(nestedMessage || flatMessage || fallbackMessage);
    }

    if (!data.html) {
        throw new Error(unavailableMessage);
    }

    return data.html;
};

// Fetch SE Impact Analytics HTML
export const fetchSeImpactAnalytics = async (accessToken) => fetchImpactAnalyticsHtml(
    accessToken,
    API_FETCH_SE_IMPACT_STATS,
    'SE Activities & Impact Analysis report is currently unavailable.',
    'Unable to load SE Activities & Impact Analysis Analytics. Please try again.',
);

// Fetch VE Impact Analytics HTML
export const fetchVeImpactAnalytics = async (accessToken) => fetchImpactAnalyticsHtml(
    accessToken,
    API_FETCH_VE_IMPACT_STATS,
    'VE Activities & Impact Analysis report is currently unavailable.',
    'Unable to load VE Activities & Impact Analysis Analytics. Please try again.',
);

// Fetch Leadership Internal SE Analytics (Phase 1-B)
export const fetchLeadershipInternalSEAnalytics = async (accessToken, filter, region = 'all') => {
    const query = new URLSearchParams({
        filter: filter || 'Month',
        region: region || 'all',
    }).toString();

    const response = await fetch(`${API_FETCH_LEADERSHIP_INTERNAL_SE_ANALYTICS}?${query}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response, 'Unable to load Leadership Analytics. Please try again.');
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
}

// Fetch Leadership Partner Analytics (Phase 2-B)
export const fetchLeadershipPartnerAnalytics = async (
    accessToken,
    filter,
    region = 'all',
    compareCompanies
) => {
    const params = {
        filter: filter || 'Month',
        region: region || 'all',
    };

    if (compareCompanies) {
        const compareParam = Array.isArray(compareCompanies)
            ? compareCompanies.filter(Boolean).join(',')
            : String(compareCompanies);
        if (compareParam) {
            params.compareCompanies = compareParam;
        }
    }

    const query = new URLSearchParams(params).toString();

    const response = await fetch(`${API_FETCH_LEADERSHIP_PARTNER_ANALYTICS}?${query}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response, 'Unable to load Leadership Analytics. Please try again.');
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
}

// Fetch Leadership Partner Company Analytics (Phase 3-B)
export const fetchLeadershipPartnerCompanyAnalytics = async (
    accessToken,
    filter,
    company
) => {
    const params = {
        filter: filter || 'Month',
        company: company || '',
    };

    const query = new URLSearchParams(params).toString();

    const response = await fetch(`${API_FETCH_LEADERSHIP_PARTNER_COMPANY_ANALYTICS}?${query}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response, 'Unable to load Leadership Analytics. Please try again.');
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
}

// Fetch Leadership Bootcamp Stats Overview
export const fetchLeadershipBootcampStats = async (accessToken, params = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null) return;
        const textValue = String(value).trim();
        if (!textValue || textValue === 'All') return;
        queryParams.set(key, textValue);
    });

    const query = queryParams.toString();
    const endpoint = query ? `${API_FETCH_LEADERSHIP_BOOTCAMP_STATS}?${query}` : API_FETCH_LEADERSHIP_BOOTCAMP_STATS;

    const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response, 'Unable to load Bootcamp Stats. Please try again.');
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
}

// Fetch Leadership Bootcamp Stats Participants
export const fetchLeadershipBootcampParticipants = async (accessToken, params = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null) return;
        const textValue = String(value).trim();
        if (!textValue || textValue === 'All') return;
        queryParams.set(key, textValue);
    });

    const query = queryParams.toString();
    const endpoint = query ? `${API_FETCH_LEADERSHIP_BOOTCAMP_PARTICIPANTS}?${query}` : API_FETCH_LEADERSHIP_BOOTCAMP_PARTICIPANTS;

    const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response, 'Unable to load participant statuses. Please try again.');
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
}






// Fetch Existing Demo Session
export const fetchExistingDemoSession = async (accessToken, id) => {

    const response = await fetch(API_FETCH_EXISTING_DEMO_SESSION(id), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();

}


// Create Customer Demo Session
export const createCustomerDemoSession = async (accessToken, params, id) => {
    const response = await fetch(API_CREATE_CUSTOMER_DEMO_SESSION(id), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(params),
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
};


// Create Internal Demo Session
export const createInternalDemoSession = async (accessToken, params, id) => {
    const response = await fetch(API_CREATE_INTERNAL_DEMO_SESSION(id), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(params),
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
};


export const deleteCustomerDemoSession = async (accessToken) => {
    const response = await fetch(API_DELETE_DEMO_SESSION, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
}



// Get Sales Walkthorugh
export const fetchSalesWalkthorugh = async (accessToken) => {
    const response = await fetch(API_GET_SALES_WALKTHROUGH, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
}



export const updateSalesWalkthorugh = async (accessToken) => {
    const response = await fetch(API_UPDATE_SALES_WALKTHROUGH_STATUS, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ tutorialCompleted: true }),
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
}


// Update Demo Session Status
export const updateDemoSessionStatus = async (accessToken, params) => {
    const response = await fetch(API_UPDATE_DEMO_SESSION_STATUS, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(params),
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
}









// ----------------------Disclaimer----------------------//
export const getPartnerDisclaimer = async (accessToken) => {
    const response = await fetch(API_GET_PARTNER_DISCLAIMER, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
}

export const updateDisclaimerStatus = async (accessToken, params) => {
    console.log(params)
    const response = await fetch(API_UPDATE_DISCLAIMER_STATUS, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(params),
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
}
// Fetch the Analytics Filter
export const fetchAnalyticsFilters = async (accessToken) => {
    const response = await fetch(API_GET_ANALYTICS_FILTER, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
}












// Get Upgrade Patches
export const getUpgardePatches = async (accessToken) => {
    const response = await fetch(API_GET_UPGRADE_PATCHES, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        throw new Error(errorMessage);
    }

    return await response.json();
}// Get Tenant Scenario Groups
export const fetchYadsTenantScenarioGroups = async (accessToken) => {
    const response = await fetch(API_GET_TENANT_SCENARIO_GROUPS, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) throw new Error(errorMessage);

    return await response.json();
};

export const fetchYadsPollingStatus = async (accessToken) => {
  const response = await fetch(API_GET_POLLING_STATUS, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  return await response.json(); // returns an array of status entries
};
export const postYadsDemoIngestion = async (payload, accessToken) => {
  const response = await fetch(API_YADS_DEMO_INGESTION, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    body: JSON.stringify(payload)
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  return await response.json(); // assuming it returns success msg or ingestion ID
};



// apiService.js
export const postYadsScheduleIngestion = async (payload, accessToken) => {
  const response = await fetch(API_SCHEDULE_YADS_DEMO_INGESTION, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  return await response.json(); // expect success / job id
};



export const deleteYadsScheduleIngestion = async (taskId, payload, accessToken) => {
  const response = await fetch(API_CANCEL_YADS_SCHEDULE(taskId), {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload), // backend expects tenant creds in body
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  return await response.json(); // expect { success / status / message }
};



// apiService.js

export const patchYadsTenantDetails = async (taskId, payload, accessToken) => {
  const res = await fetch(API_YADS_SCHEDULE(taskId), {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload), // tenant-only fields
  });

  const errorMessage = await handleErrors(res);
  if (errorMessage) throw new Error(errorMessage);
  return await res.json();
};

export const postYadsReschedule = async (taskId, payload, accessToken) => {
  const res = await fetch(API_YADS_SCHEDULE(taskId), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload), // scenarios[] and/or scheduledTime + tenant fields
  });

  const errorMessage = await handleErrors(res);
  if (errorMessage) throw new Error(errorMessage);
  return await res.json();
};





// Recurring Scheduling
export const postYadsRecurringScheduleIngestion = async (payload, accessToken) => {
  const res = await axios.post(
    API_RECURRING_SCHEDULE_YADS_DEMO_INGESTION,
    payload,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    }
  );
  return res.data;
};



export const deleteYadsRecurringScheduleIngestion = async (taskId, payload, accessToken) => {
  const response = await fetch(API_DELETE_YADS_RECURRING_SCHEDULE(taskId), {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload), // backend expects tenant creds in body
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  return await response.json(); // expect { success / status / message }
};






// ---- PATCH call ----
export const patchYadsRecurringSchedule = async (taskId, payload, accessToken) => {
  const response = await fetch(API_PATCH_YADS_RECURRING_SCHEDULE(taskId), {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),  // contains tenantDetails, selectedScenarios, scheduleCriteria, endDate|null
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  // some PATCH endpoints return 204
  if (response.status === 204) return { status: "OK" };

  return await response.json(); // expect updated object / status / message
};







// POST: Onboard Tenant
export const onboardTenantApi = async (accessToken, payload) => {
  const response = await fetch(API_ONBOARD_TENANT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  return await response.json();
};



export const forgotPasswordApi = async (payload) => {
    const response = await fetch(API_FORGOT_PASSWORD, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }, // no Authorization header
        body: JSON.stringify(payload),
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) throw new Error(errorMessage);

    // Most APIs return 200 with a generic message to avoid account enumeration
    return await response.json().catch(() => ({}));
};



/**
 * PATCH: change password by URL (no auth token)
 * @param {{ uid:string, token:string, password:string, cnewpassword:string }} payload
 */
export const changePasswordByUrlApi = async (payload) => {
    const response = await fetch(API_CHANGE_PASSWORD_BY_URL, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) {
        const err = new Error(errorMessage);
        try { err.status = response.status; } catch (_) { }
        throw err;
    }

    // many APIs return no body on success; guard decode
    try {
        return await response.json();
    } catch {
        return {};
    }
};




// ✅ NEW: PATCH user tenant details
export const patchUserTenant = async (payload, accessToken) => {
  const response = await fetch(API_PATCH_USER_TENANT, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  if (response.status === 204) return { status: 'OK' };
  return await response.json();
};



// Cancel a running ingestion (current tab)
export const cancelIngestionApi = async (taskId, accessToken) => {
    const response = await fetch(API_CANCEL_INGESTION(taskId), {
        method: 'POST',                       // if backend uses DELETE, change to 'DELETE'
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    });

    const errorMessage = await handleErrors(response);
    if (errorMessage) throw new Error(errorMessage);

    // response example:
    // { "success": "Cancellation requested", "taskId": "fe4c9a28-264a-40ff-8830-b0c3f6df4882" }
    return await response.json();
};




// ✅ NEW: DELETE user tenant
export const deleteUserTenantApi = async (payload, accessToken) => {
  const response = await fetch(API_DELETE_USER_TENANT, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload), // { tenantUrl }
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  // backend may return 204 No Content
  if (response.status === 204) return { status: 'OK' };

  // backend may return json
  try {
    return await response.json();
  } catch {
    return { status: 'OK' };
  }
};


// Admin Users
export const fetchUserModuleDetails = async (accessToken) => {
  const response = await fetch(API_ADMIN_USER_MODULE_DETAILS, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  return await response.json();
};

export const updatePendingRequestApi = async (requestId, payload, accessToken) => {
  const sanitizedPayload = buildPendingRequestUpdatePayload(payload);

  const response = await fetch(API_ADMIN_PENDING_REQUEST(requestId), {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(sanitizedPayload),
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  if (response.status === 204) return { status: 'OK' };
  return await response.json();
};

export const approvePendingRequestApi = async (requestId, accessToken) => {
  const response = await fetch(API_ADMIN_PENDING_REQUEST(requestId), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({}),
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  if (response.status === 204) return { status: 'OK' };
  return await response.json();
};

export const rejectPendingRequestApi = async (requestId, accessToken) => {
  const response = await fetch(API_ADMIN_PENDING_REQUEST(requestId), {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  if (response.status === 204) return { status: 'OK' };
  return await response.json();
};

export const deleteUserApi = async (payload, accessToken) => {
  const response = await fetch(API_ADMIN_ACCOUNTS, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  if (response.status === 204) return { status: 'OK' };
  return await response.json();
};

export const updateUserApi = async (payload, accessToken) => {
  const response = await fetch(API_ADMIN_ACCOUNTS, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  if (response.status === 204) return { status: 'OK' };
  return await response.json();
};

export const createAdminAccountApi = async (payload, accessToken) => {
  const response = await fetch(API_ADMIN_ACCOUNTS, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  const errorMessage = await handleErrors(
    response,
    'Unable to create the account. Please try again.'
  );
  if (errorMessage) throw new Error(errorMessage);

  return await response.json();
};

export const resetAdminUserPasswordApi = async (email, accessToken) => {
  const response = await fetch(API_ADMIN_RESET_USER_PASSWORD, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ email }),
  });

  const errorMessage = await handleErrors(
    response,
    'Unable to reset the password. Please try again.'
  );
  if (errorMessage) throw new Error(errorMessage);

  return await response.json();
};

export const createAccountApi = async (payload) => {
  const response = await fetch(API_ACCOUNT_REQUEST, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    //   Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  if (response.status === 204) return { status: 'OK' };
  return await response.json();
};

export const fetchPendingRequestCount = async (accessToken) => {
  const response = await fetch(API_ADMIN_PENDING_REQUEST_COUNT, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  return await response.json();
};

export const fetchAccountTypeMapping = async () => {
  const response = await fetch(API_ADMIN_ACCOUNT_TYPE_MAPPING, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  return await response.json();
};

// Admin Shared Tenants
export const getAdminSharedTenants = async (accessToken) => {
  const response = await fetch(API_ADMIN_SHARED_TENANT, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });

  const errorMessage = await handleErrors(response, 'Unable to load shared tenants.');
  if (errorMessage) {
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  return await response.json();
};

export const getAdminSharedTenantDetail = async (accessToken, tenantType, tenantNumber) => {
  const params = new URLSearchParams({
    tenantType: String(tenantType),
    tenantNumber: String(tenantNumber),
  });

  const response = await fetch(`${API_ADMIN_SHARED_TENANT}?${params.toString()}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });

  const errorMessage = await handleErrors(response, 'Unable to load tenant details.');
  if (errorMessage) {
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  return await response.json();
};

export const patchAdminSharedTenant = async (accessToken, payload, fallbackMessage) => {
  const response = await fetch(API_ADMIN_SHARED_TENANT, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  const errorMessage = await handleErrors(response, fallbackMessage);
  if (errorMessage) {
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  if (response.status === 204) return { status: 'OK' };
  try {
    return await response.json();
  } catch {
    return { status: 'OK' };
  }
};

export const updateAdminSharedTenantStatus = async (accessToken, payload) =>
  patchAdminSharedTenant(accessToken, payload, 'Unable to change tenant status. Please try again.');

export const updateAdminSharedTenant = async (accessToken, payload) =>
  patchAdminSharedTenant(accessToken, payload, 'Unable to update tenant. Please try again.');

export const createAdminSharedTenant = async (accessToken, payload) => {
  const response = await fetch(API_ADMIN_SHARED_TENANT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  const errorMessage = await handleErrors(response, 'Unable to onboard tenant. Please try again.');
  if (errorMessage) {
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  return await response.json();
};

export const updateAdminBookingLabels = async (accessToken, payload) => {
  const response = await fetch(API_ADMIN_BOOKING_LABELS, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  const errorMessage = await handleErrors(response, 'Unable to update labels. Please try again.');
  if (errorMessage) {
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  if (response.status === 204) return { status: 'OK' };
  try {
    return await response.json();
  } catch {
    return { status: 'OK' };
  }
};

export const updateAdminBookingTenantFeatures = async (accessToken, payload) => {
  const response = await fetch(API_ADMIN_BOOKING_TENANT_FEATURES, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  const errorMessage = await handleErrors(response, 'Unable to update tenant features. Please try again.');
  if (errorMessage) {
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  if (response.status === 204) return { status: 'OK' };
  try {
    return await response.json();
  } catch {
    return { status: 'OK' };
  }
};

export const getAdminBookingVersionFeatures = async (accessToken) => {
  const response = await fetch(API_ADMIN_BOOKING_VERSION_FEATURES, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  const errorMessage = await handleErrors(response, 'Unable to load version features. Please try again.');
  if (errorMessage) {
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  return await response.json();
};

export const upsertAdminBookingVersionFeatures = async (accessToken, payload) => {
  const response = await fetch(API_ADMIN_BOOKING_VERSION_FEATURES, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  const errorMessage = await handleErrors(response, 'Unable to save version features. Please try again.');
  if (errorMessage) {
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  if (response.status === 204) return { status: 'OK' };
  try {
    return await response.json();
  } catch {
    return { status: 'OK' };
  }
};

export const deleteAdminBookingVersionFeatures = async (accessToken, payload) => {
  const response = await fetch(API_ADMIN_BOOKING_VERSION_FEATURES, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  const errorMessage = await handleErrors(response, 'Unable to delete version features. Please try again.');
  if (errorMessage) {
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  try {
    return await response.json();
  } catch {
    return { status: 'OK' };
  }
};

export const updateAdminFaultStatus = async (accessToken, payload) => {
  const response = await fetch(API_ADMIN_UPDATE_FAULT_STATUS, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  const errorMessage = await handleErrors(response, 'Unable to update fault status. Please try again.');
  if (errorMessage) {
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  if (response.status === 204) return { status: 'OK' };
  try {
    return await response.json();
  } catch {
    return { status: 'OK' };
  }
};

export const resetAdminSharedTenantPasswords = async (accessToken, payload) => {
  const response = await fetch(API_ADMIN_MASS_PASSWORD_RESET, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (response.ok) {
    return data || { successfulResets: [], failedResets: [], invalidUsers: [] };
  }

  const errorMessage = extractErrorMessage(data, '', 'Unable to reset passwords. Please try again.');
  const error = new Error(errorMessage);
  error.status = response.status;
  throw error;
};

export const runAdminSharedTenantCleanup = async (accessToken) => {
  const response = await fetch(API_ADMIN_CHECK_CLEAN_TENANTS, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({}),
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (response.ok) {
    return { success: true, ...(data || {}) };
  }

  if (data?.error && Array.isArray(data.error)) {
    return { success: false, errors: data.error };
  }

  const errorMessage = extractErrorMessage(data, '', 'Unable to run shared tenant cleanup. Please try again.');
  const error = new Error(errorMessage);
  error.status = response.status;
  throw error;
};

export const releaseBookingTenant = async (accessToken, payload) => {
  const response = await fetch(API_RELEASE_TENENT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  const errorMessage = await handleErrors(response, 'Unable to release tenant. Please try again.');
  if (errorMessage) {
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  try {
    return await response.json();
  } catch {
    return { status: 'OK' };
  }
};

export const deleteAdminSharedTenant = async (accessToken, payload) => {
  const response = await fetch(API_ADMIN_SHARED_TENANT, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    const errorMessage = extractErrorMessage(data, '', 'Unable to delete tenant. Please try again.');
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  if (response.status === 204) return data || { status: 'OK' };
  return data || { status: 'OK' };
};

export const updateAdminAlertMessageApi = async (message, accessToken) => {
  const response = await fetch(API_ADMIN_ALERT_MESSAGE, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ message }),
  });

  const errorMessage = await handleErrors(
    response,
    'Unable to save the alert. Please try again.'
  );
  if (errorMessage) throw new Error(errorMessage);

  return await response.json();
};

export const deleteAdminAlertMessageApi = async (accessToken) => {
  const response = await fetch(API_ADMIN_ALERT_MESSAGE, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    const errorMessage = extractErrorMessage(data, '', 'Unable to delete the alert. Please try again.');
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  if (data?.error) {
    if (/no alert message found/i.test(String(data.error))) {
      return { alreadyDeleted: true };
    }
    throw new Error(data.error);
  }

  return data || { success: true };
};

// Email migration
export const requestEmailChange = async (newEmail, accessToken) => {
  const response = await fetch(API_EMAIL_CHANGE_REQUEST, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ newEmail }),
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  if (response.status === 204) return { status: 'OK' };
  try {
    return await response.json();
  } catch {
    return { status: 'OK' };
  }
};

export const verifyEmailChangeToken = async (token) => {
  const response = await fetch(API_EMAIL_CHANGE_VERIFY(token), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  if (response.status === 204) return { status: 'OK' };
  try {
    return await response.json();
  } catch {
    return { status: 'OK' };
  }
};

export const resendEmailChange = async (newEmail, accessToken) => {
  const response = await fetch(API_EMAIL_CHANGE_RESEND, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ newEmail }),
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) throw new Error(errorMessage);

  if (response.status === 204) return { status: 'OK' };
  try {
    return await response.json();
  } catch {
    return { status: 'OK' };
  }
};

export const checkEmailMigrationStatusApi = async (accessToken) => {
  const response = await fetch(API_EMAIL_CHANGE_STATUS, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });

  const errorMessage = await handleErrors(response);
  if (errorMessage) {
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  try {
    return await response.json();
  } catch {
    return {};
  }
};
